import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, Dialog, Typography } from '@material-ui/core';
import _ from 'lodash';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { baseCassConfirm } from '../baseCss';
import { bedP as P } from '../../../bsApp';
import { ServiceTable } from '../../ServiceOrder';
import { bedStatusAPI } from '../../../../../apis';

export default function CancelConfirmation({ closePop, open, allData, confirmHandle }) {
  const baseClasses = baseCassConfirm();
  const [withdrawOrderList, setWithdrawOrderList] = useState([]);

  const getDischgCleansingList = async () => {
    try {
      const params = {
        tableId: allData?.bedStatusId,
        tableName: 'B',
      };
      const { result } = await bedStatusAPI.getDischgCleansingList(params);
      setWithdrawOrderList(
        _.map(
          _.filter(result, (item) => item?.orderStatus !== 'C' && item?.orderStatus !== 'Y'),
          (item) => ({ ...item, withdraw: true })
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDischgCleansingList();
  }, []);

  const handleSelectWithdraw = (bsCleansingRequestId) => () => {
    setWithdrawOrderList((prev) =>
      prev.map((item) => ({
        ...item,
        withdraw: item.bsCleansingRequestId === bsCleansingRequestId ? !item.withdraw : item.withdraw,
      }))
    );
  };

  const confirmClick = () => {
    if (typeof confirmHandle === 'function') {
      confirmHandle({
        bsCleansingRequestId: _.filter(withdrawOrderList, (item) => item.withdraw).map(
          (item) => item.bsCleansingRequestId
        ),
      });
    }
  };

  return (
    <Dialog open={open} maxWidth={false}>
      <div className={baseClasses.root}>
        <div className={baseClasses.header} style={{ padding: '1.88rem 0' }}>
          <Typography className={baseClasses.headerTitle}>
            {i18n.t('BEDSTATUS_CANCEL_DISCHARGE_ORDER_CONFIRMATION')}
          </Typography>
          <ButtonBase
            id="bed_cancelconfirmation_close_btn"
            className={baseClasses.closeIcon}
            onClick={closePop}
            style={{ margin: '0' }}
          >
            <CloseIcon />
          </ButtonBase>
        </div>
        <Typography className={baseClasses.areYouSureYouWou} style={{ fontSize: '1.125rem' }}>
          {i18n.t('BEDSTATUS_ARE_YOU_SURE_TO_CANCEL_THE_DISCHARGE_ORDER_OF_BED', { bed: allData?.[P.bedNo] })}
        </Typography>
        {withdrawOrderList?.length > 0 && (
          <Box mt="1.88rem">
            <ServiceTable orderList={withdrawOrderList} handleSelectWithdraw={handleSelectWithdraw} withdraw />
          </Box>
        )}
        <Box display="flex" justifyContent="center" style={{ margin: '3rem 0 2.5rem 0' }}>
          <ButtonBase
            id="bed_cancelconfirmation_cancel"
            className={baseClasses.cancelBtn}
            style={{ marginRight: '1.313rem' }}
            onClick={closePop}
          >
            {i18n.t('BEDSTATUS_CANCEL')}
          </ButtonBase>
          <ButtonBase id="bed_cancelconfirmation_confirm" className={baseClasses.configBtn} onClick={confirmClick}>
            {i18n.t('BEDSTATUS_CONFIRM')}
          </ButtonBase>
        </Box>
      </div>
    </Dialog>
  );
}
